// Auto-generert ved build (scripts/gen-version.js) — ikke rediger manuelt.
export const APP_VERSION = '2026.10.11.1426';
